import React, { useState } from 'react'
import classnames from 'classnames'
import ActionDropdown from '@SiteComponents/ActionDropdown'
import ArrowDown from '@Images/workspace_row_arrow_down.svg'

import {
  IWorkspaceUser,
} from '@SiteModules/WorkspaceUser/types'

import './AccountUserWorkspaceRow.scss'

interface AccountUserWorkspaceRowProps {
  readonly index: number
  readonly workspaceUser: IWorkspaceUser
  deleteWorkspaceUser(): void
}

const AccountUserWorkspaceRow: React.FC<AccountUserWorkspaceRowProps> = props => {
  const {
    index,
    workspaceUser,
  } = props

  const {
    accessType,
    workspaceName,
  } = workspaceUser.attributes

  const [showDropdown, setShowDropdown] = useState(false)

  const cleanWorkspaceName = workspaceName.replace(/[^a-zA-Z]/g, '-').replace(/^-+|-+$/g, '').replace(/-+/g, '-')
  const accessElementId = `workspace_row_access_${cleanWorkspaceName}`
  const classNameForClickOutsideListenerAccessDropdown = `AccountUserWorkspacesTable__action-dropdown-element-${cleanWorkspaceName}`

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown)
  }

  const handleDeleteWorkspaceUser = () => {
    setShowDropdown(false)
    props.deleteWorkspaceUser()
  }

  const actionDropdownList = (
    <ul>
      <li
        className="AccountUserWorkspacesTable__action-dropdown-item"
        onClick={handleDeleteWorkspaceUser}
      >
        <div className="AccountUserWorkspaceRow__action-dropdown-item-text AccountUserWorkspaceRow__action-dropdown-item-text-remove">
          Remove access
        </div>
      </li>
    </ul>
  )

  const renderActionDropdown = () => {
    return (
      <ActionDropdown
        showDropdown={showDropdown}
        dropdownList={actionDropdownList}
        classNamesForListContainer="AccountUserWorkspacesTable__action-dropdown AccountUserView__element"
        classNameForClickOutsideListener={classNameForClickOutsideListenerAccessDropdown}
        classNameOfScrollContainer="AccountUserView"
        idOfDropdownElement={accessElementId}
        idOfPortalContainer="settings"
        dropdownOffsetX={135}
        dropdownOffsetY={5}
        dropdownWidth={255} // same width as AccountUserWorkspacesTable__action-dropdown
        setShowDropdown={setShowDropdown}
      />
    )
  }

  return (
    <tr
      className={classnames(
        { 'AccountUserWorkspaceRow__even': index % 2 === 0 },
        { 'AccountUserWorkspaceRow__uneven': index % 2 === 1 }
      )}
    >
      <td
        className="AccountUserWorkspacesTable__workspace-name AccountUserWorkspaceRow__workspace-name"
      >
        {workspaceName}
      </td>
      <td
        className="AccountUserWorkspacesTable__access AccountUserWorkspaceRow__access"
      >
        <div
          className={`AccountUserWorkspaceRow__access-button-wrapper ${classNameForClickOutsideListenerAccessDropdown}`}
          id={accessElementId}
        >
          <div
            className="AccountUserWorkspaceRow__access-button"
            onClick={toggleDropdown}
          >
            <div>
              {accessType === 'full' ? 'Full access' : 'Edit access'}
            </div>
            <ArrowDown />
          </div>
          {showDropdown && renderActionDropdown()}
        </div>
      </td>
    </tr>
  )
}

export default AccountUserWorkspaceRow
